import { fromPairs } from 'lodash';

import convertToOption from './utils/convert-to-option';

const MEDIA_ONSITE = 'Media Onsite';
const MEDIA_OFFSITE = 'Media Offsite';
export const CONSUMER_INSIGHTS = 'Consumer Insights';
export const CREATIVE = 'Creative';
const DATA = 'Data';
export const OTHER = 'Other';
export const MEDIA = 'Media';

export const BUSINESSES = {
  MEDIA_ONSITE,
  MEDIA_OFFSITE,
  CREATIVE,
  CONSUMER_INSIGHTS,
  DATA,
  OTHER,
};

export const businessOptions = Object.values(BUSINESSES).map(convertToOption);

export const BUSINESS_TYPES = [CONSUMER_INSIGHTS, CREATIVE, OTHER, MEDIA];

export const billingTypesEnum = {
  EXTERNAL: 'External',
  INTERNAL: 'Internal',
  WKZ: 'WKZ',
};

export const MEDIA_BUSINESSES = [MEDIA_ONSITE, MEDIA_OFFSITE];

export const billableFields = [
  'billableBudgetMediaExternal',
  'billableBudgetMediaInternal',
  'billableBudgetMediaWKZ',
  'billableBudgetCreativeExternal',
  'billableBudgetCreativeInternal',
  'billableBudgetCreativeWKZ',
  'billableBudgetCIExternal',
  'billableBudgetCIInternal',
  'billableBudgetCIWKZ',
  'billableBudgetOtherExternal',
  'billableBudgetOtherInternal',
  'billableBudgetOtherWKZ',
];

export const countries = [
  { label: 'DE', countryCode: 'DE', name: 'Germany' },
  { label: 'AT', countryCode: 'AT', name: 'Austria' },
  { label: 'CH', countryCode: 'CH', name: 'Switzerland' },
  { label: 'NL', countryCode: 'NL', name: 'Netherlands' },
  { label: 'BE', countryCode: 'BE', name: 'Belgium' },
  { label: 'FR', countryCode: 'FR', name: 'France' },
  { label: 'IT', countryCode: 'IT', name: 'Italy' },
  { label: 'ES', countryCode: 'ES', name: 'Spain' },
  { label: 'DK', countryCode: 'DK', name: 'Denmark' },
  { label: 'SE', countryCode: 'SE', name: 'Sweden' },
  { label: 'NO', countryCode: 'NO', name: 'Norway' },
  { label: 'FI', countryCode: 'FI', name: 'Finland' },
  { label: 'PL', countryCode: 'PL', name: 'Poland' },
  { label: 'CZ', countryCode: 'CZ', name: 'Czech Republic' },
  { label: 'UK', countryCode: 'UK', name: 'United Kingdom' },
  { label: 'IE', countryCode: 'IE', name: 'Ireland' },
  { label: 'SK', countryCode: 'SK', name: 'Slovakia' },
  { label: 'SI', countryCode: 'SI', name: 'Slovenia' },
  { label: 'LT', countryCode: 'LT', name: 'Lithuania' },
  { label: 'LV', countryCode: 'LV', name: 'Latvia' },
  { label: 'EE', countryCode: 'EE', name: 'Estonia' },
  { label: 'HR', countryCode: 'HR', name: 'Croatia' },
  { label: 'PT', countryCode: 'PT', name: 'Portugal' },
  { label: 'HU', countryCode: 'HU', name: 'Hungary' },
  { label: 'RO', countryCode: 'RO', name: 'Romania' },
];

export const CWTemplate2026 = [
  { countryCode: 'DE', countrySplit: 0.34 },
  { countryCode: 'AT', countrySplit: 0.05 },
  { countryCode: 'CH', countrySplit: 0.12 },
  { countryCode: 'NL', countrySplit: 0.06 },
  { countryCode: 'BE', countrySplit: 0.05 },
  { countryCode: 'FR', countrySplit: 0.07 },
  { countryCode: 'IT', countrySplit: 0.07 },
  { countryCode: 'ES', countrySplit: 0.04 },
  { countryCode: 'DK', countrySplit: 0.03 },
  { countryCode: 'SE', countrySplit: 0.03 },
  { countryCode: 'NO', countrySplit: 0.02 },
  { countryCode: 'FI', countrySplit: 0.01 },
  { countryCode: 'PL', countrySplit: 0.06 },
  { countryCode: 'CZ', countrySplit: 0.0042 },
  { countryCode: 'UK', countrySplit: 0.0042 },
  { countryCode: 'IE', countrySplit: 0.0042 },
  { countryCode: 'SK', countrySplit: 0.0042 },
  { countryCode: 'SI', countrySplit: 0.0042 },
  { countryCode: 'LT', countrySplit: 0.0042 },
  { countryCode: 'LV', countrySplit: 0.0042 },
  { countryCode: 'EE', countrySplit: 0.0042 },
  { countryCode: 'HR', countrySplit: 0.0041 },
  { countryCode: 'PT', countrySplit: 0.0041 },
  { countryCode: 'HU', countrySplit: 0.0041 },
  { countryCode: 'RO', countrySplit: 0.0041 },
];

export const supportedCountryLanguagePairs = {
  AT: ['DE'],
  BE: ['FR', 'NL'],
  CH: ['DE', 'FR', 'IT'],
  CZ: ['CS'],
  DE: ['DE', 'EN'],
  DK: ['DA'],
  EE: ['ET'],
  ES: ['ES'],
  FI: ['FI'],
  FR: ['FR'],
  HR: ['HR'],
  HU: ['HU'],
  IE: ['EN'],
  IT: ['IT'],
  LT: ['LT'],
  LV: ['LV'],
  NL: ['NL'],
  NO: ['NO'],
  PL: ['PL'],
  PT: ['PT'],
  RO: ['RO'],
  SE: ['SV'],
  SI: ['SL'],
  SK: ['SK'],
  UK: ['EN'],
};

export const COUNTRY_CODE_TO_NAMES = fromPairs(
  countries.map(({ countryCode, name }) => [countryCode, name]),
);

export const PROJECT_VIEW = 'Project';
export const QUOTE_VIEW = 'Quote';
export const PROJECT_QUOTE_VIEW_ERROR =
  'There was an error loading the primary quote';

export const commercialIncentives = [
  'Brand Activation',
  'Internationalization',
  'Sustainability Campaigns',
  'Zalando Exclusives',
  'Collabary Influencer / Creative Campaigns',
  'New to Zalando Brand Launch Package',
  'ZMS Upsells',
  'One Size Fits All sponsorships',
  'Discretionary Media',
  'PP Loyalty Program',
  'Kickstarter: Brand Boost',
];

export const otherIncentives = [
  'Side Letter Agreement',
  'Diversity Fund',
  'Plus Early Access',
  'Wildcard Campaigns',
  'ZBD or Category Moment',
  'Commercial Package',
  'Custom Brand Launch',
  'Cyber Week Support',
  "CCD's (Partner Program)",
];

export const commercialIncentivesOptions = [
  {
    label: 'Commercial Incentives',
    options: commercialIncentives.map(convertToOption),
  },
  {
    label: 'Other Incentives',
    options: otherIncentives.map(convertToOption),
  },
];

export const delayReasonsEnum = {
  PO_MISSING: 'PO missing',
  IO_MISSING: 'IO missing',
  PO_IO_MISSING: 'IO+PO missing',
  PC_INPUT_NEEDED: 'PC input needed',
  CLARIFICATION_NEEDED: 'Clarification needed',
  TECH_ISSUE: 'Tech issue',
};

export const delayReasonsOptions =
  Object.values(delayReasonsEnum).map(convertToOption);
